module.exports = __webpack_public_path__ + "static/media/Step 7-Jobs.8d61f597.png";